import mainLogo from '../../images/G4R/G4R_logo_color.png';
import squareLogo from '../../images/G4R/G4R_logo_color.png';
import bannerLogoWhite from '../../images/G4R/G4R_logo_white.png';
import banner01 from '../../images/G4R/G4R_banners_01_01.1.webp';
import banner02 from '../../images/G4R/G4R_banners_01_02.1.webp';
import banner03 from '../../images/G4R/G4R_banners_01_03.1.webp';
import banner04 from '../../images/G4R/G4R_banners_01_04.1.webp';
import car123 from '../../images/G4R/123_kicks.jpg';
import box123 from '../../images/G4R/123_g4r.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'G4R',
    defaultStoreLink: 'pecas.g4r.com.br',
    defaultContactEmail: 'pecas@g4r.com.br',
    whatsappNumber: '86 2107 1311',
    CNPJname: 'Alemanha Veiculos LTDA',
    CNPJ: '05.422.156/0001-84',
    CNPJaddress: 'Av. João XXIII, 3.480 - São Cristóvão - Cidade: Teresina/PI - 64045-000',
    launchDate: '14/02/2025',

    multiContact: {
        'Audi': '86 99404 8150',
        'Chevrolet': '86 2106 4000',
        'Honda motos': '86 3083 4444',
        'Nissan': '86 99416 2834',
        'Renault': '86 9402 6073',
        'Volkswagen': '86 99409 8904'
    },
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "audi",
        "chevrolet",
        "honda motos",
        "nissan",
        "renault",
        "volkswagen",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "AUDI CENTER TERESINA",
        "JAPAN MOTOS MATRIZ",
        "JAPAN NISSAN TERESINA",
        "Via Paris Bairro dos Noivos",
        "ALEMANHA VW",
    ],

    disabledSellers: [
        "CANADA GM",
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: bannerLogoWhite,
    squareLogo: bannerLogoWhite,
    bannerImg01: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais compatíveis com <span style="font-weight: bold;">seu veículo</span>, direto das concessionárias <span style="font-weight: bold;">G4R</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo G4R teve início em 1998 com a nomeação pela General Motors da concessionária Canadá Veículos como autorizada Chevrolet no Piauí. Atualmente, representamos as marcas Chevrolet, Renault, Nissan, Volkswagen, Audi, e Honda Motos,  além do Carhoo, a maior loja e o mais completo site de seminovos do Piauí. Com o passar do tempo nossa atuação também se expandiu para outras regiões e hoje temos unidades em Teresina, Parnaíba e Floriano no Piauí e Caxias, no Maranhão. Buscando sempre estar alinhado com as mais modernas práticas de gestão e inovação, o Grupo G4R se destaca também pelo foco na qualidade e satisfação dos clientes o que nos proporcionou trilhar um caminho de sucesso e hoje é destaque no cenário automotivo local e nacional.',
        ],
        link: 'https://grupo4rodas.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: '',
        Facebook: '',
        LinkedIn: 'https://www.linkedin.com/company/grupo-g4r/',
        Youtube: 'https://www.youtube.com/channel/UCLSUn0V-d3YJjZD5jF6exAw',
        Twitter: '',
    },

    footerContent: [],
}